const BUILD = {
  REACT_APP_ENV: process.env.REACT_APP_ENV,
  REACT_APP_API: process.env.REACT_APP_API,
  REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
  REACT_APP_GRAPHQL: process.env.REACT_APP_GRAPHQL,
  REACT_APP_CONSULT_APPT_TYPE_ID: process.env.REACT_APP_CONSULT_APPT_TYPE_ID,
  REACT_APP_PARENT_NAVIGATION_APPT_TYPE_ID: process.env.REACT_APP_PARENT_NAVIGATION_APPT_TYPE_ID,
  REACT_APP_INTAKE_APPT_TYPE_ID: process.env.REACT_APP_INTAKE_APPT_TYPE_ID,
  REACT_APP_GCP_PROJECT_ID: process.env.REACT_APP_GCP_PROJECT_ID,
  REACT_APP_GCP_ERROR_REPORTING_API_KEY: process.env.REACT_APP_GCP_ERROR_REPORTING_API_KEY,
  REACT_APP_EHR_GRAPHQL: process.env.REACT_APP_EHR_GRAPHQL,
  REACT_APP_EHR_UI_URL: process.env.REACT_APP_EHR_UI_URL,
  REACT_APP_CONSULT_TYPE_FORM_ID: process.env.REACT_APP_CONSULT_TYPE_FORM_ID,
  REACT_APP_EVERNORTH_TYPE_FORM_ID: process.env.REACT_APP_EVERNORTH_TYPE_FORM_ID,
  REACT_APP_LYRA_TYPE_FORM_ID: process.env.REACT_APP_LYRA_TYPE_FORM_ID,
  REACT_APP_PCSCREENER_TYPE_FORM_ID: process.env.REACT_APP_PCSCREENER_TYPE_FORM_ID,
  REACT_APP_NEWACCOUNT_TYPE_FORM_ID: process.env.REACT_APP_NEWACCOUNT_TYPE_FORM_ID,
  REACT_APP_NEWACCOUNTANDCONSULT_TYPE_FORM_ID: process.env.REACT_APP_NEWACCOUNTANDCONSULT_TYPE_FORM_ID
};

export type EnvName = keyof typeof BUILD;

declare global {
  interface Window {
    env?: Partial<Record<EnvName, string>>;
  }
}

export function loadValue(name: EnvName): string {
  return window.env?.[name] ?? BUILD[name] ?? "";
}

const ANDROID_EMULATOR_HOST = "10.0.2.2";
const isOnAndroidEmulator = window.location.href.includes(ANDROID_EMULATOR_HOST);

function loadAll(): Record<EnvName, string> {
  const names = Object.keys(BUILD) as EnvName[];
  return Object.fromEntries(names.map(name => [name, loadValue(name)])) as Record<EnvName, string>;
}

const config = {
  env: {
    ...loadAll(),
    REACT_APP_API: isOnAndroidEmulator ? `http://${ANDROID_EMULATOR_HOST}:8000` : loadValue("REACT_APP_API"),
    REACT_APP_GRAPHQL: isOnAndroidEmulator
      ? `http://${ANDROID_EMULATOR_HOST}:8000/graphql`
      : loadValue("REACT_APP_GRAPHQL")
  }
};

export default config;
